// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideUpload as RawLucideUpload } from "lucide-react";
export const LucideUpload = /* @__PURE__ */ createIcon(RawLucideUpload, "LucideUpload", 2);
